<template>
  <div ref="btn" class="absolute-fill d-flex justify-center align-center">
    <!-- Note that we use mousedown.capture to make sure the 'edit' event triggers before the blob becomes selected (since we ignore it on the first attempt) -->
    <v-btn
      v-blur
      v-bind:style="{ transform: `scale(${scale})` }"
      height="56" min-width="56" target="_blank"
      :dark="isDark"
      :elevation="isTransparent ? 0 : 6"
      :rounded="!isTransparent"
      :color="blob.btn.color || 'primary'"
      v-bind="(isInteractive && blob.btn.url) ? { href: blob.btn.url } : {}"
      @click="isInteractive && $emit('click')"
    >
      <span v-if="blob.btn.text" v-bind:class="{ 'mr-1': blob.btn.url }" v-html="blob.btn.text" />
      <v-icon v-if="!blob.btn.form" v-show="!isTransparent" v-html="mdiOpenInNew" />
    </v-btn>
  </div>
</template>


<style scoped>
.v-btn {
  pointer-events: auto;
  transform-origin: center center;
  transition: none;
  font-size: 1.04em;
}
</style>


<script>
import { getLuminanace } from '@/utils/group-video-template.js';
import { mdiOpenInNew } from '@mdi/js';

const TRANSPARENT_RE = /(^rgba\([^,]+,[^,]+,[^,]+,\s*0+\s*\)$)|(^#[\da-f]{3}0$)|(^#[\da-f]{6}00$)/i;

export default {
  name: 'btn-blob',

  props: [ 'isOwner', 'isSelected', 'mode', 'blob' ],

  created() {
    Object.assign(this, { mdiOpenInNew });
  },

  computed: {
    isInteractive() {
      return !(this.isOwner && [ 'design', 'purchase', 'edit' ].includes(this.mode));
    },

    isTransparent() {
      return TRANSPARENT_RE.test(this.blob.btn.color || '');
    },

    scale() {
      return this.blob.h / 56;
    },

    isDark() {
      return getLuminanace(this.blob.btn.color) < .5;
    },

    needsUpdate() {
      const b = this.blob.btn;
      return [ b.url, b.text, this.isSelected ];
    }
  },

  methods: {
    async adjust() {
      // We do this asynchronously to avoid interfering with updates made elsewhere
      await this.$nextTick();
      const w = this.$refs.btn.firstChild.clientWidth * this.scale;
      if (this.blob.w != w)
        this.blob.w = w;
    }
  },

  watch: {
    needsUpdate: {
      immediate: true,
      handler() {
        if (this.isSelected)
          this.adjust();
      }
    }
  }
}
</script>
